import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { debounce, interval, Subject, take, takeUntil } from 'rxjs';
import { FileModel } from '../../../../../models/file.model';
import { FileService } from '../../../../../services/file.service';

@Component({
  selector: 'app-seminar-file-sequence',
  templateUrl: './seminar-file-sequence.component.html',
  styleUrl: './seminar-file-sequence.component.scss',
  standalone: false,
})
export class SeminarFileSequenceComponent implements OnInit, OnDestroy {
  @Input() files: FileModel[] = [];
  @Input() seminarId: number;
  @Output() filesChange = new EventEmitter<FileModel[]>();

  private reorderSubject = new Subject<FileModel[]>();
  private destroy$ = new Subject<void>();
  public isUpdating = false;

  constructor(private fileService: FileService) {}

  ngOnInit(): void {
    this.reorderSubject
      .pipe(
        debounce(() => interval(700)),
        takeUntil(this.destroy$)
      )
      .subscribe(files => this.persistOrder(files));
  }

  onReorder(): void {
    // Ensure positions reflect current index
    this.files.forEach((f, idx) => (f.position = idx + 1));
    this.files = [...this.files];
    this.filesChange.emit(this.files);
    this.reorderSubject.next(this.files);
  }

  private persistOrder(reordered: FileModel[]): void {
    this.isUpdating = true;
    const orderPayload = reordered.map((f, idx) => ({
      id: f.id,
      position: idx + 1,
    }));
    this.fileService
      .updateFileOrder(orderPayload, this.seminarId)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.isUpdating = false;
        },
        error: () => {
          this.isUpdating = false;
          console.error('Failed to update file order');
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
